import {Component} from '@angular/core';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-home',
	templateUrl:'./HomePage.html',
	styles: [],
	styleUrls:['./HomePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaTextDirective,
		WaTagDirective,
		RouterModule,
		WaButtonDirective,
		WaDividerDirective,
		WaCardDirective,
],
	standalone:true
})
export class HomePage
{
}
